const data = {
  // 订单状态
  dealStatus: {
    1: '待确认', // 用户下单
    2: '已发货', // 客服确认并发货，可填写物流信息
    3: '已收货', // 用户收到货物并确认
    4: '已评价', // 用户发布评价信息
    9: '已作废'
  }
}

export default {
  data
}



// WEBPACK FOOTER //
// ./src/utils/config.js